import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CarDetail from "../components/CarDetail";
import InquiryForm from "../components/InquiryForm";
import api from "../api/api"; // Updated import

const CarDetailPage = () => {
  const { id } = useParams(); // Fetch the car ID from the URL parameters
  const [car, setCar] = useState(null);

  useEffect(() => {
    // Fetch car details by ID
    api.get(`/cars/${id}`) // Ensure URL matches API routes
      .then((response) => setCar(response.data))
      .catch((error) => console.error("Error fetching car details:", error));
  }, [id]);

  if (!car) {
    return <p>Loading car details...</p>;
  }

  return (
    <div>
      <CarDetail car={car} />
      <h3>Interested in this car? Submit an inquiry!</h3>
      <InquiryForm carId={id} />
    </div>
  );
};

export default CarDetailPage;
